var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{domProps:{"innerHTML":_vm._s(_vm.product.type !== 'external' ? _vm.product.price_html : _vm.product.short_description)}})
}
var staticRenderFns = []

export { render, staticRenderFns }